module.exports = "/_next/static/images/Iso27018@2x-f0a13d0087f6e07a57bec58532803fcf.png";